<template>
  <div id="app" v-bind:style="{ backgroundImage: backgroundUrl }">
    <link rel="stylesheet" type="text/css" v-bind:href="cssUrl" />
    <transition name="fade">
      <div v-if="loading" class="loading-overlay">
        <cm-indicator></cm-indicator>
      </div>
    </transition>
    <div class="container">
      <router-view />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "/sass/_variables.scss";
@import "/sass/_variables_client.scss";
#app {
  background: url($default_background) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

  @media (max-width: $sm) {
    /* This is more important than an inline style */
    background-image: none !important;
  }
}
</style>
<script>
import browserButtons from "@/utils/browser-buttons.js";
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "mainPayment",
  mixins: [browserButtons],
  created() {
    this.setHostedCheckoutId(this.getQueryVariable("hostedCheckoutId"));
    if (!this.hostedCheckoutId) {
      this.setOverlayBox(true);
      this.$router.push({ path: `/payment-failure` });
    } else {
      this.getState().then((res) => {
        if (!res) {
          return;
        }

        if (res.page === "payment-success") {
          window.location.href = res.pageDetails.url;
        } else {
          this.$i18n.locale = this.language.toLowerCase();
          document
            .getElementsByTagName("html")[0]
            .setAttribute("lang", this.language.toLowerCase());

          // only redirect if it's not the current page
          if (this.$route.path !== `/${res.page}`) {
            this.$router.push({ path: `/${res.page}` });
          }
        }
      });
    }
  },
  computed: {
    ...paymentNS.mapGetters([
      "language",
      "page",
      "loading",
      "hostedCheckoutId",
      "backgroundUrl",
      "cssUrl",
    ]),
  },
  methods: {
    ...paymentNS.mapActions(["getState", "restart"]),
    ...paymentNS.mapMutations([
      "setHostedCheckoutId",
      "setLoading",
      "setOverlayBox",
    ]),
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return undefined;
    },
  },
};
</script>
